<style>
.list-group-item.active{background: #103374!important; border:none; color: #fff!important;}
.list-group-item-action:hover, .list-group-item-action:focus {color: #000!important;}

</style>
<template>
<template v-if="mtree.include_unused || !node.suspended">
    <a
    v-if="!mtree.search || this.getChildProps(node, 'name').some( ai => ai.toLowerCase().includes(mtree.search.toLowerCase()) )" href="#"
    v-on:click="mtree.select(node, history)" :data-bs-dismiss="multiple ? '' : 'modal'" class="list-group-item list-group-item-action"
    style="text-align: left; padding:8px 4px;"
    :class="{'active': (mtree.selectedNode ? (mtree.selectedNode.id == node.id) : false && !multiple) || mtree.selectedNodeIds.includes(node.id), 'disabled': mtree.selectable.length && !mtree.selectable.includes(node.type)}">
        <span v-if="history.length">{{ "　".repeat(history.length) }}</span>
        <div class="btn btn-dark btn-sm" v-if="node.type == 'ROOT'">본사</div>
        <div class="btn btn-info btn-sm" v-if="node.type == 'LOCAL'">지사</div>
      <div class="btn btn-success btn-sm" v-if="node.type == 'ENTERPRISE'">학원</div>
      <div class="btn btn-danger btn-sm" style="font-size:11px; padding:2px 4px;" v-if="node.type == 'CLASS'">클래스</div>
        <template v-if="node.suspended"><strike>{{ node.name }}</strike></template>
        <template v-else>{{ node.name }}</template>

        </a>
  <template v-for="child in node.child" v-bind:key="child.id" >
      <node v-if="(!mtree.selectable.length || (this.getChildProps(child, 'type').some( ai => mtree.selectable.includes(ai) ))) && (mtree.show_class || node.type != 'ENTERPRISE')" :node="child" :history="[...history, child]" :mtree="mtree" :multiple="multiple" ></node>
    </template>

</template>
</template>
<script>
export default {
  name: "node",
  props: {
    node: Object,
    mtree: Object,
    cnt: Number,
    multiple: Boolean,
    history: {
      type: Array,
      default: []
    }
  },
  methods: {
    getChildProps(obj, propname){
      var result = [obj[propname]];
      if(obj.child){
        obj.child.forEach(element => {
          result = [...result, ...this.getChildProps(element, propname)];
        });
      }
      return result;
    }
  }
};
</script>
